/*=========================================================================================
  File Name: moduleTransactionMng.js
  Description: Transaction Module
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 30062020
==========================================================================================*/

import state from './moduleTransactionMngState.js'
import mutations from './moduleTransactionMngMutations.js'
import actions from './moduleTransactionMngActions.js'
import getters from './moduleTransactionMngGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

